(ns hypnos.dme.tile.field.patient-name
  "Field for the patient first and last name."
  (:require [hypnos.i18n :refer [tr]]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; field

(defn field
  ([state]
   (field state {:disabled false}))
  ([state {:keys [disabled] :or {disabled false}}]
   [:div.field.is-horizontal
    [:div.field-label.is-normal
     [:label.label (tr :ui.label/name)]]
    [:div.field-body
     [:div.field
      [:p.control.is-expanded
       [:input.input
        {:type        :text
         :disabled    disabled
         :placeholder (when-not disabled (tr :ui.placeholder/first-name))
         :value       (get-in @state [:patient :patient/first-name :value])
         :on-change   (fn [e]
                        (let [old-value (get-in @state [:patient :patient/first-name :value])
                              new-value (-> e .-target .-value)
                              changed?  (or (get-in @state [:patient :patient/first-name :dirty?])
                                            (not= new-value old-value))]
                          (swap! state assoc-in
                                 [:patient :patient/first-name :value]
                                 new-value)
                          (swap! state assoc-in
                                 [:patient :patient/first-name :dirty?]
                                 changed?)))
         :on-focus    (fn [_]
                        (swap! state assoc-in
                               [:patient :patient/first-name :touched?]
                               true))}]]]
     [:div.field
      [:div.field
       [:p.control.is-expanded
        [:input.input
         {:type        :text
          :disabled    disabled
          :placeholder (when-not disabled (tr :ui.placeholder/last-name))
          :value       (get-in @state [:patient :patient/last-name :value])
          :on-change   (fn [e]
                         (let [old-value (get-in @state [:patient :patient/last-name :value])
                               new-value (-> e .-target .-value)
                               changed?  (or (get-in @state [:patient :patient/last-name :dirty?])
                                             (not= new-value old-value))]
                           (swap! state assoc-in
                                  [:patient :patient/last-name :value]
                                  new-value)
                           (swap! state assoc-in
                                  [:patient :patient/last-name :dirty?]
                                  changed?)))
          :on-focus    (fn [_]
                         (swap! state assoc-in
                                [:patient :patient/last-name :touched?]
                                true))}]]]]]]))
